import React from 'react';
import Button from './Button';


const ClientsPage = ({ navigate }) => {
  const clients = [
    { name: 'Safebite', image: 'safebite.png', link: 'https://safebite.suppersquad.app' },
    { name: 'Zarder', image: 'zarderFull.png', link: 'https://www.zarder.app/' },
    { name: 'Middlegrounds', image: 'middlegrounds.png', link: 'https://middlegroundsnews.com' },
    { name: 'Supper Squad', image: 'suppersquad.png', link: 'https://suppersquad.app' },
    { name: 'Pippa', image: 'pippa.png', link: 'https://getpippa.app' },
    { name: 'Brik', image: 'brik.png', link: 'https://www.the-brik.com' },
    { name: 'Codely', image: 'codely.png', link: 'https://codelyapp.vercel.app' },
    { name: 'ARU Learning', image: 'arulearning.png', link: 'https://arulearning.vercel.app' },
    { name: 'Albumified', image: 'albumified.png', link: 'https://albumified.com/' },
    { name: 'Icebreakers', image: 'icebreakers.png', link: 'https://icebreakers-daily.vercel.app' },
    { name: 'Vocal', image: 'vocal.png', link: 'https://vocal-mixer-pro.vercel.app' },
  ];

  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background">
      {/* Header Section */}
      <div className="text-center mb-20">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold uppercase tracking-tighter leading-none mb-6 pt-[60px] md:pt-0 text-foreground">
          OUR CLIENTS
        </h1>
        <p className="text-[19.5px] md:text-xl lg:text-2xl text-muted-foreground max-w-2xl mx-auto leading-tight">
          We partner with ambitious startups, fast-growing brands, and industry disruptors to design digital experiences that scale.
        </p>
      </div>

      {/* Grid of Transparent, Borderless Logo Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-24">
        {clients.map((client, index) => (
          <a 
            key={index}
            href={client.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-transparent h-28 md:h-32 w-full flex items-center justify-center p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 select-none relative overflow-hidden cursor-pointer"
          >
            <img
              src={`/client-images/${client.image}`}
              alt={`${client.name} Logo`}
              className="max-h-12 md:max-h-16 max-w-full object-contain opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 ease-out"
              draggable="false"
            />
          </a>
        ))}
      </div>

      {/* Bottom CTA section - Expanded to take the full width of the grid container */}
      <div className="mt-24 p-8 md:p-16 border-2 border-border text-center bg-background w-full flex flex-col items-center gap-6 shadow-[6px_6px_0px_#3F3F46]">
        <h3 className="text-3xl md:text-5xl font-black uppercase tracking-tighter" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
          Ready to be our next success story?
        </h3>
        <p className="text-muted-foreground max-w-xl text-lg leading-tight">
          Let's collaborate to build something exceptional. Get in touch with our team today to discuss your next breakthrough project.
        </p>
        <Button 
          size="large" 
          onClick={() => {
            const contactSection = document.getElementById('contact');
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: 'smooth' });
            } else {
              navigate('/');
              setTimeout(() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }
          }}
        >
          Work With Us
        </Button>
      </div>
    </div>
  );
};

export default ClientsPage;
